import style from './style.module.scss'

const MenuTopHeader = ({ menu }) => {
    if (!menu) return null

    const menuFormated = Object.values(menu)

    if (menuFormated.length === 0) {
        return null
    }

    return (
        <nav className={style.menu}>
            <ul>
                {menuFormated.map((m) => (
                    <li key={m.ID}>
                        <a href={m.url}>{m.title}</a>
                    </li>
                ))}
            </ul>
        </nav>
    )
}

export default MenuTopHeader
